'use client';

import {
  Text,
  Flex,
  Icon,
  Separator,
  Timestamp,
  Pill,
  Button,
  ButtonGroup,
} from '@/_components';
import styles from './Notes.module.css';
import { Fragment, type FC } from 'react';
import type { NotesProps } from './Notes.types';

export const Notes: FC<NotesProps> = ({ notes, onDeleteNote }) => {
  const filteredNotes = notes?.filter((note) => !note.removed) || [];

  if (!filteredNotes?.length) return null;

  return (
    <Flex className={styles.notes} isColumn={true}>
      {filteredNotes.map((note, key) => {
        const onDelete = () => onDeleteNote(note);

        const isLast: boolean = key === filteredNotes?.length - 1;

        const noteSeparator: Array<string> = note?.text?.split?.(': ') || [];
        const noteUser: string = noteSeparator?.[0] || '';
        const noteText: string = noteSeparator.slice(1).join(': ');

        return (
          <Fragment key={key}>
            <Flex gap={6} paddingX={4} paddingY={8}>
              <Icon size={24} name="note" />
              <Flex isColumn={true} className="wp-100">
                <Flex isYCentered={true} gap={2} isBetween={true}>
                  <Flex isYCentered={true} gap={2}>
                    <Flex isYCentered={true} gap={2}>
                      <Text type="small" fontWeight="semi-bold">
                        {noteUser}
                      </Text>
                      {note?.from_firm_user && (
                        <Pill size="small" label="Staff" intent="secondary" />
                      )}
                    </Flex>
                    <Text type="small" color="disabled">
                      /
                    </Text>
                    <Text type="small" color="secondary">
                      <Timestamp
                        timestamp={note?.created_at}
                        isFromNow={true}
                      />
                    </Text>
                  </Flex>
                  <ButtonGroup>
                    <Button
                      intent="danger-secondary"
                      size="tiny"
                      isIconOnly={true}
                      iconLeft="trash"
                      value="Delete Note"
                      onClick={onDelete}
                    />
                  </ButtonGroup>
                </Flex>
                <Text type="paragraph">{noteText}</Text>
              </Flex>
            </Flex>
            {!isLast && <Separator />}
          </Fragment>
        );
      })}
    </Flex>
  );
};
